import Vue from 'vue'
import App from './App.vue'


import firebase from '@firebase/app';
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify';
import VueI18n from 'vue-i18n';

import messages_en from '@/lang/en'
import messages_fr from '@/lang/fr'
import messages_hu from '@/lang/hu'
Vue.use(VueI18n)
const getNavigatorLanguage = () => (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';

const i18n = new VueI18n({
  locale: getNavigatorLanguage().substring(0,2), // set locale
  fallbackLocale: 'en',
  messages: {... messages_en, ...messages_fr, ...messages_hu} // set locale messages
})

Vue.config.productionTip = false
let configOptions = {
    apiKey: "AIzaSyDreGT2CpjlKcExFi_7FXkqzP6E0pHU34w",
    authDomain: "ogame-275212.firebaseapp.com",
    databaseURL: "https://ogame-275212.firebaseio.com",
    projectId: "ogame-275212",
    storageBucket: "ogame-275212.appspot.com",
    messagingSenderId: "82679522125",
    appId: "1:82679522125:web:d57fc02c5eb558b0580d04"
  };
firebase.initializeApp(configOptions);

new Vue({
  router,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
